// Backend action codes - these match the action_code values in the database
import { getScopeFromValue } from '@features/invitations/utils/getScopeFromParam';

export const ACTION_CODES = {
  // --- Report Actions ---
  APPROVE_CHURCH_REPORT: 'APPROVE_CHURCH_REPORT',
  APPROVE_DISTRICT_REPORT: 'APPROVE_DISTRICT_REPORT',
  APPROVE_NATION_REPORT: 'APPROVE_NATION_REPORT',
  APPROVE_OWN_CHURCH_REPORT: 'APPROVE_OWN_CHURCH_REPORT',
  APPROVE_OWN_DISTRICT_REPORT: 'APPROVE_OWN_DISTRICT_REPORT',
  APPROVE_OWN_NATION_REPORT: 'APPROVE_OWN_NATION_REPORT',

  // --- KPI / Activity / Template Assignment ---
  ASSIGN_ACTIVITY_KPI: 'ASSIGN_ACTIVITY_KPI',
  ASSIGN_CHURCH_DEPARTMENT: 'ASSIGN_CHURCH_DEPARTMENT',
  ASSIGN_CHURCH_REPORT_TEMPLATE: 'ASSIGN_CHURCH_REPORT_TEMPLATE',
  ASSIGN_DISTRICT_REPORT_TEMPLATE: 'ASSIGN_DISTRICT_REPORT_TEMPLATE',
  ASSIGN_NATION_REPORT_TEMPLATE: 'ASSIGN_NATION_REPORT_TEMPLATE',
  SYNC_CHURCH_REPORT_TEMPLATE: 'SYNC_CHURCH_REPORT_TEMPLATE',
  SYNC_DISTRICT_REPORT_TEMPLATE: 'SYNC_DISTRICT_REPORT_TEMPLATE',
  SYNC_NATION_REPORT_TEMPLATE: 'SYNC_NATION_REPORT_TEMPLATE',
  ASSIGN_CHURCH_REPORT_TEMPLATE_ACTIVITY: 'ASSIGN_CHURCH_REPORT_TEMPLATE_ACTIVITY',
  ASSIGN_DISTRICT_REPORT_TEMPLATE_ACTIVITY: 'ASSIGN_DISTRICT_REPORT_TEMPLATE_ACTIVITY',
  ASSIGN_NATION_REPORT_TEMPLATE_ACTIVITY: 'ASSIGN_NATION_REPORT_TEMPLATE_ACTIVITY',
  ASSIGN_CHURCH_REPORT_TEMPLATE_SUB_GROUP: 'ASSIGN_CHURCH_REPORT_TEMPLATE_SUB_GROUP',
  ASSIGN_DISTRICT_REPORT_TEMPLATE_SUB_GROUP: 'ASSIGN_DISTRICT_REPORT_TEMPLATE_SUB_GROUP',
  ASSIGN_NATION_REPORT_TEMPLATE_SUB_GROUP: 'ASSIGN_NATION_REPORT_TEMPLATE_SUB_GROUP',

  // --- Bulk Assignment Actions ---
  BULK_ASSIGN_CHURCH_REPORT_TEMPLATE: 'BULK_ASSIGN_CHURCH_REPORT_TEMPLATE',
  BULK_ASSIGN_DISTRICT_REPORT_TEMPLATE: 'BULK_ASSIGN_DISTRICT_REPORT_TEMPLATE',
  BULK_ASSIGN_OVERRIDE_CHURCH_REPORT_TEMPLATE: 'BULK_ASSIGN_OVERRIDE_CHURCH_REPORT_TEMPLATE',
  BULK_ASSIGN_OVERRIDE_DISTRICT_REPORT_TEMPLATE: 'BULK_ASSIGN_OVERRIDE_DISTRICT_REPORT_TEMPLATE',
  BULK_UNASSIGN_CHURCH_REPORT_TEMPLATE: 'BULK_UNASSIGN_CHURCH_REPORT_TEMPLATE',
  BULK_UNASSIGN_DISTRICT_REPORT_TEMPLATE: 'BULK_UNASSIGN_DISTRICT_REPORT_TEMPLATE',

  // --- Invite Actions ---
  CANCEL_INVITE_CHURCH: 'CANCEL_INVITE_CHURCH',
  CANCEL_INVITE_DISTRICT: 'CANCEL_INVITE_DISTRICT',
  CANCEL_INVITE_NATION: 'CANCEL_INVITE_NATION',
  SEND_INVITE_CHURCH: 'SEND_INVITE_CHURCH',
  SEND_INVITE_DISTRICT: 'SEND_INVITE_DISTRICT',
  SEND_INVITE_NATION: 'SEND_INVITE_NATION',

  // --- Create Actions ---
  CREATE_ACTIVITY: 'CREATE_ACTIVITY',
  CREATE_CHURCH: 'CREATE_CHURCH',
  CREATE_CHURCH_FINANCIAL_CATEGORY: 'CREATE_CHURCH_FINANCIAL_CATEGORY',
  CREATE_DEPARTMENT: 'CREATE_DEPARTMENT',
  CREATE_CHURCH_DEPARTMENT_REPORT_DOCUMENT_CATEGORY: 'CREATE_CHURCH_DEPARTMENT_REPORT_DOCUMENT_CATEGORY',
  CREATE_DISTRICT_DEPARTMENT_REPORT_DOCUMENT_CATEGORY: 'CREATE_DISTRICT_DEPARTMENT_REPORT_DOCUMENT_CATEGORY',
  CREATE_NATION_DEPARTMENT_REPORT_DOCUMENT_CATEGORY: 'CREATE_NATION_DEPARTMENT_REPORT_DOCUMENT_CATEGORY',
  UPDATE_CHURCH_DEPARTMENT_REPORT_DOCUMENT_CATEGORY: 'UPDATE_CHURCH_DEPARTMENT_REPORT_DOCUMENT_CATEGORY',
  UPDATE_DISTRICT_DEPARTMENT_REPORT_DOCUMENT_CATEGORY: 'UPDATE_DISTRICT_DEPARTMENT_REPORT_DOCUMENT_CATEGORY',
  UPDATE_NATION_DEPARTMENT_REPORT_DOCUMENT_CATEGORY: 'UPDATE_NATION_DEPARTMENT_REPORT_DOCUMENT_CATEGORY',
  REMOVE_CHURCH_DEPARTMENT_REPORT_DOCUMENT_CATEGORY: 'REMOVE_CHURCH_DEPARTMENT_REPORT_DOCUMENT_CATEGORY',
  REMOVE_DISTRICT_DEPARTMENT_REPORT_DOCUMENT_CATEGORY: 'REMOVE_DISTRICT_DEPARTMENT_REPORT_DOCUMENT_CATEGORY',
  REMOVE_NATION_DEPARTMENT_REPORT_DOCUMENT_CATEGORY: 'REMOVE_NATION_DEPARTMENT_REPORT_DOCUMENT_CATEGORY',
  ENABLE_CHURCH_DEPARTMENT_REPORT_DOCUMENT_CATEGORY: 'ENABLE_CHURCH_DEPARTMENT_REPORT_DOCUMENT_CATEGORY',
  ENABLE_DISTRICT_DEPARTMENT_REPORT_DOCUMENT_CATEGORY: 'ENABLE_DISTRICT_DEPARTMENT_REPORT_DOCUMENT_CATEGORY',
  ENABLE_NATION_DEPARTMENT_REPORT_DOCUMENT_CATEGORY: 'ENABLE_NATION_DEPARTMENT_REPORT_DOCUMENT_CATEGORY',
  DISABLE_CHURCH_DEPARTMENT_REPORT_DOCUMENT_CATEGORY: 'DISABLE_CHURCH_DEPARTMENT_REPORT_DOCUMENT_CATEGORY',
  DISABLE_DISTRICT_DEPARTMENT_REPORT_DOCUMENT_CATEGORY: 'DISABLE_DISTRICT_DEPARTMENT_REPORT_DOCUMENT_CATEGORY',
  DISABLE_NATION_DEPARTMENT_REPORT_DOCUMENT_CATEGORY: 'DISABLE_NATION_DEPARTMENT_REPORT_DOCUMENT_CATEGORY',
  UPDATE_CHURCH_DEPARTMENT_REPORT_DOCUMENT_CATEGORY_ORIGIN: 'UPDATE_CHURCH_DEPARTMENT_REPORT_DOCUMENT_CATEGORY_ORIGIN',
  UPDATE_DISTRICT_DEPARTMENT_REPORT_DOCUMENT_CATEGORY_ORIGIN: 'UPDATE_DISTRICT_DEPARTMENT_REPORT_DOCUMENT_CATEGORY_ORIGIN',
  UPDATE_NATION_DEPARTMENT_REPORT_DOCUMENT_CATEGORY_ORIGIN: 'UPDATE_NATION_DEPARTMENT_REPORT_DOCUMENT_CATEGORY_ORIGIN',
  CREATE_CHURCH_PRESENTATION_LAYOUT: 'CREATE_CHURCH_PRESENTATION_LAYOUT',
  CREATE_DISTRICT_PRESENTATION_LAYOUT: 'CREATE_DISTRICT_PRESENTATION_LAYOUT',
  CREATE_NATION_PRESENTATION_LAYOUT: 'CREATE_NATION_PRESENTATION_LAYOUT',
  UPDATE_CHURCH_PRESENTATION_LAYOUT: 'UPDATE_CHURCH_PRESENTATION_LAYOUT',
  UPDATE_DISTRICT_PRESENTATION_LAYOUT: 'UPDATE_DISTRICT_PRESENTATION_LAYOUT',
  UPDATE_NATION_PRESENTATION_LAYOUT: 'UPDATE_NATION_PRESENTATION_LAYOUT',
  ENABLE_CHURCH_PRESENTATION_LAYOUT: 'ENABLE_CHURCH_PRESENTATION_LAYOUT',
  ENABLE_DISTRICT_PRESENTATION_LAYOUT: 'ENABLE_DISTRICT_PRESENTATION_LAYOUT',
  ENABLE_NATION_PRESENTATION_LAYOUT: 'ENABLE_NATION_PRESENTATION_LAYOUT',
  DISABLE_CHURCH_PRESENTATION_LAYOUT: 'DISABLE_CHURCH_PRESENTATION_LAYOUT',
  DISABLE_DISTRICT_PRESENTATION_LAYOUT: 'DISABLE_DISTRICT_PRESENTATION_LAYOUT',
  DISABLE_NATION_PRESENTATION_LAYOUT: 'DISABLE_NATION_PRESENTATION_LAYOUT',
  DELETE_CHURCH_PRESENTATION_LAYOUT: 'DELETE_CHURCH_PRESENTATION_LAYOUT',
  DELETE_DISTRICT_PRESENTATION_LAYOUT: 'DELETE_DISTRICT_PRESENTATION_LAYOUT',
  DELETE_NATION_PRESENTATION_LAYOUT: 'DELETE_NATION_PRESENTATION_LAYOUT',
  UPDATE_CHURCH_PRESENTATION_LAYOUT_ORIGIN: 'UPDATE_CHURCH_PRESENTATION_LAYOUT_ORIGIN',
  UPDATE_DISTRICT_PRESENTATION_LAYOUT_ORIGIN: 'UPDATE_DISTRICT_PRESENTATION_LAYOUT_ORIGIN',
  UPDATE_NATION_PRESENTATION_LAYOUT_ORIGIN: 'UPDATE_NATION_PRESENTATION_LAYOUT_ORIGIN',
  CREATE_DISTRICT: 'CREATE_DISTRICT',
  CREATE_FINANCE_ALLOCATION_RULE: 'CREATE_FINANCE_ALLOCATION_RULE',
  CREATE_FINANCE_DEDUCTIBLE: 'CREATE_FINANCE_DEDUCTIBLE',
  UPDATE_FINANCE_DEDUCTIBLE: 'UPDATE_FINANCE_DEDUCTIBLE',
  DISABLE_FINANCE_DEDUCTIBLE: 'DISABLE_FINANCE_DEDUCTIBLE',
  ENABLE_FINANCE_DEDUCTIBLE: 'ENABLE_FINANCE_DEDUCTIBLE',
  DELETE_FINANCE_DEDUCTIBLE: 'DELETE_FINANCE_DEDUCTIBLE',
  DISABLE_CHURCH_FINANCIAL_CATEGORY: 'DISABLE_CHURCH_FINANCIAL_CATEGORY',
  DISABLE_FINANCE_ALLOCATION_RULE: 'DISABLE_FINANCE_ALLOCATION_RULE',
  ENABLE_CHURCH_FINANCIAL_CATEGORY: 'ENABLE_CHURCH_FINANCIAL_CATEGORY',
  ENABLE_FINANCE_ALLOCATION_RULE: 'ENABLE_FINANCE_ALLOCATION_RULE',
  CREATE_KPI: 'CREATE_KPI',
  CREATE_NATION: 'CREATE_NATION',
  CREATE_REPORT_TAG: 'CREATE_REPORT_TAG',
  CREATE_REPORT_SUB_GROUP: 'CREATE_REPORT_SUB_GROUP',
  CREATE_CHURCH_REPORT_TEMPLATE: 'CREATE_CHURCH_REPORT_TEMPLATE',
  CREATE_DISTRICT_REPORT_TEMPLATE: 'CREATE_DISTRICT_REPORT_TEMPLATE',
  CREATE_NATION_REPORT_TEMPLATE: 'CREATE_NATION_REPORT_TEMPLATE',
  UPDATE_CHURCH_REPORT_TEMPLATE: 'UPDATE_CHURCH_REPORT_TEMPLATE',
  UPDATE_DISTRICT_REPORT_TEMPLATE: 'UPDATE_DISTRICT_REPORT_TEMPLATE',
  UPDATE_NATION_REPORT_TEMPLATE: 'UPDATE_NATION_REPORT_TEMPLATE',
  UPDATE_CHURCH_REPORT_TEMPLATE_ORIGIN: 'UPDATE_CHURCH_REPORT_TEMPLATE_ORIGIN',
  UPDATE_DISTRICT_REPORT_TEMPLATE_ORIGIN: 'UPDATE_DISTRICT_REPORT_TEMPLATE_ORIGIN',
  UPDATE_NATION_REPORT_TEMPLATE_ORIGIN: 'UPDATE_NATION_REPORT_TEMPLATE_ORIGIN',
  ENABLE_CHURCH_REPORT_TEMPLATE: 'ENABLE_CHURCH_REPORT_TEMPLATE',
  ENABLE_DISTRICT_REPORT_TEMPLATE: 'ENABLE_DISTRICT_REPORT_TEMPLATE',
  ENABLE_NATION_REPORT_TEMPLATE: 'ENABLE_NATION_REPORT_TEMPLATE',
  DISABLE_CHURCH_REPORT_TEMPLATE: 'DISABLE_CHURCH_REPORT_TEMPLATE',
  DISABLE_DISTRICT_REPORT_TEMPLATE: 'DISABLE_DISTRICT_REPORT_TEMPLATE',
  DISABLE_NATION_REPORT_TEMPLATE: 'DISABLE_NATION_REPORT_TEMPLATE',

  // --- Remove Assignment Actions ---
  REMOVE_ACTIVITY_KPI: 'REMOVE_ACTIVITY_KPI',
  REMOVE_CHURCH_DEPARTMENT: 'REMOVE_CHURCH_DEPARTMENT',
  REMOVE_CHURCH_REPORT_TEMPLATE: 'REMOVE_CHURCH_REPORT_TEMPLATE',
  REMOVE_DISTRICT_REPORT_TEMPLATE: 'REMOVE_DISTRICT_REPORT_TEMPLATE',
  REMOVE_NATION_REPORT_TEMPLATE: 'REMOVE_NATION_REPORT_TEMPLATE',
  REMOVE_CHURCH_REPORT_TEMPLATE_ACTIVITY: 'REMOVE_CHURCH_REPORT_TEMPLATE_ACTIVITY',
  REMOVE_DISTRICT_REPORT_TEMPLATE_ACTIVITY: 'REMOVE_DISTRICT_REPORT_TEMPLATE_ACTIVITY',
  REMOVE_NATION_REPORT_TEMPLATE_ACTIVITY: 'REMOVE_NATION_REPORT_TEMPLATE_ACTIVITY',
  REMOVE_CHURCH_REPORT_TEMPLATE_SUB_GROUP: 'REMOVE_CHURCH_REPORT_TEMPLATE_SUB_GROUP',
  REMOVE_DISTRICT_REPORT_TEMPLATE_SUB_GROUP: 'REMOVE_DISTRICT_REPORT_TEMPLATE_SUB_GROUP',
  REMOVE_NATION_REPORT_TEMPLATE_SUB_GROUP: 'REMOVE_NATION_REPORT_TEMPLATE_SUB_GROUP',

  // --- Remove User Actions ---
  REMOVE_USER_CHURCH: 'REMOVE_USER_CHURCH',
  REMOVE_USER_CHURCH_DEPT: 'REMOVE_USER_CHURCH_DEPT',
  REMOVE_USER_DIST: 'REMOVE_USER_DIST',
  REMOVE_USER_DIST_DEPT: 'REMOVE_USER_DIST_DEPT',
  REMOVE_USER_NAT: 'REMOVE_USER_NAT',
  REMOVE_USER_NAT_DEPT: 'REMOVE_USER_NAT_DEPT',

  // --- Report Tag ---
  REOPEN_REPORT_TAG: 'REOPEN_REPORT_TAG',

  // --- Review Actions ---
  REVIEW_CHURCH_ACTIVITY_ENTRY: 'REVIEW_CHURCH_ACTIVITY_ENTRY',
  REVIEW_DISTRICT_ACTIVITY_ENTRY: 'REVIEW_DISTRICT_ACTIVITY_ENTRY',
  REVIEW_NATION_ACTIVITY_ENTRY: 'REVIEW_NATION_ACTIVITY_ENTRY',
  REVIEW_CHURCH_DEPARTMENT_REPORT: 'REVIEW_CHURCH_DEPARTMENT_REPORT',
  REVIEW_DISTRICT_DEPARTMENT_REPORT: 'REVIEW_DISTRICT_DEPARTMENT_REPORT',
  REVIEW_NATION_DEPARTMENT_REPORT: 'REVIEW_NATION_DEPARTMENT_REPORT',

  // --- Save Report Actions ---
  SAVE_CHURCH_ACTIVITY_ENTRY: 'SAVE_CHURCH_ACTIVITY_ENTRY',
  SAVE_DISTRICT_ACTIVITY_ENTRY: 'SAVE_DISTRICT_ACTIVITY_ENTRY',
  SAVE_NATION_ACTIVITY_ENTRY: 'SAVE_NATION_ACTIVITY_ENTRY',
  SAVE_CHURCH_DEPARTMENT_REPORT: 'SAVE_CHURCH_DEPARTMENT_REPORT',
  SAVE_DISTRICT_DEPARTMENT_REPORT: 'SAVE_DISTRICT_DEPARTMENT_REPORT',
  SAVE_NATION_DEPARTMENT_REPORT: 'SAVE_NATION_DEPARTMENT_REPORT',

  // --- Submit Report Actions ---
  SUBMIT_CHURCH_ACTIVITY_ENTRY: 'SUBMIT_CHURCH_ACTIVITY_ENTRY',
  SUBMIT_DISTRICT_ACTIVITY_ENTRY: 'SUBMIT_DISTRICT_ACTIVITY_ENTRY',
  SUBMIT_NATION_ACTIVITY_ENTRY: 'SUBMIT_NATION_ACTIVITY_ENTRY',
  SUBMIT_CHURCH_DEPARTMENT_REPORT: 'SUBMIT_CHURCH_DEPARTMENT_REPORT',
  SUBMIT_DEPARTMENT_REPORT: 'SUBMIT_DEPARTMENT_REPORT',
  SUBMIT_DISTRICT_DEPARTMENT_REPORT: 'SUBMIT_DISTRICT_DEPARTMENT_REPORT',
  SUBMIT_NATION_DEPARTMENT_REPORT: 'SUBMIT_NATION_DEPARTMENT_REPORT',

  VALIDATE_CHURCH_DEPARTMENT_REPORT: 'VALIDATE_CHURCH_DEPARTMENT_REPORT',
  VALIDATE_DISTRICT_DEPARTMENT_REPORT: 'VALIDATE_DISTRICT_DEPARTMENT_REPORT',
  VALIDATE_NATION_DEPARTMENT_REPORT: 'VALIDATE_NATION_DEPARTMENT_REPORT',

  UPLOAD_MEDIA_CHURCH_DEPARTMENT_REPORT: 'UPLOAD_MEDIA_CHURCH_DEPARTMENT_REPORT',
  UPLOAD_MEDIA_DISTRICT_DEPARTMENT_REPORT: 'UPLOAD_MEDIA_DISTRICT_DEPARTMENT_REPORT',
  UPLOAD_MEDIA_NATION_DEPARTMENT_REPORT: 'UPLOAD_MEDIA_NATION_DEPARTMENT_REPORT',

  REMOVE_MEDIA_CHURCH_DEPARTMENT_REPORT: 'REMOVE_MEDIA_CHURCH_DEPARTMENT_REPORT',
  REMOVE_MEDIA_DISTRICT_DEPARTMENT_REPORT: 'REMOVE_MEDIA_DISTRICT_DEPARTMENT_REPORT',
  REMOVE_MEDIA_NATION_DEPARTMENT_REPORT: 'REMOVE_MEDIA_NATION_DEPARTMENT_REPORT',

  // --- Update Actions ---
  UPDATE_ACTIVITY: 'UPDATE_ACTIVITY',
  UPDATE_CHURCH: 'UPDATE_CHURCH',
  UPDATE_CHURCH_MEMBERSHIP: 'UPDATE_CHURCH_MEMBERSHIP',
  OVERRIDE_CHURCH_MEMBERSHIP_COUNT: 'OVERRIDE_CHURCH_MEMBERSHIP_COUNT',
  UPDATE_CHURCH_FINANCIAL_CATEGORY: 'UPDATE_CHURCH_FINANCIAL_CATEGORY',
  UPDATE_DEPARTMENT: 'UPDATE_DEPARTMENT',
  UPDATE_DISTRICT: 'UPDATE_DISTRICT',
  SET_DISTRICT_HEAD_CHURCH: 'SET_DISTRICT_HEAD_CHURCH',
  UPDATE_FINANCE_ALLOCATION_RULE: 'UPDATE_FINANCE_ALLOCATION_RULE',
  UPDATE_KPI: 'UPDATE_KPI',
  UPDATE_NATION: 'UPDATE_NATION',
  UPDATE_REPORT_TAG: 'UPDATE_REPORT_TAG',

  // --- Update User Status: ACTIVE ---
  UPDATE_USER_STATUS_ACTIVE_CHURCH: 'UPDATE_USER_STATUS_ACTIVE_CHURCH',
  UPDATE_USER_STATUS_ACTIVE_CHURCH_DEPT: 'UPDATE_USER_STATUS_ACTIVE_CHURCH_DEPT',
  UPDATE_USER_STATUS_ACTIVE_DIST: 'UPDATE_USER_STATUS_ACTIVE_DIST',
  UPDATE_USER_STATUS_ACTIVE_DIST_DEPT: 'UPDATE_USER_STATUS_ACTIVE_DIST_DEPT',
  UPDATE_USER_STATUS_ACTIVE_NAT: 'UPDATE_USER_STATUS_ACTIVE_NAT',
  UPDATE_USER_STATUS_ACTIVE_NAT_DEPT: 'UPDATE_USER_STATUS_ACTIVE_NAT_DEPT',

  // --- Update User Status: ARCHIVED ---
  UPDATE_USER_STATUS_ARCHIVED_CHURCH: 'UPDATE_USER_STATUS_ARCHIVED_CHURCH',
  UPDATE_USER_STATUS_ARCHIVED_CHURCH_DEPT: 'UPDATE_USER_STATUS_ARCHIVED_CHURCH_DEPT',
  UPDATE_USER_STATUS_ARCHIVED_DIST: 'UPDATE_USER_STATUS_ARCHIVED_DIST',
  UPDATE_USER_STATUS_ARCHIVED_DIST_DEPT: 'UPDATE_USER_STATUS_ARCHIVED_DIST_DEPT',
  UPDATE_USER_STATUS_ARCHIVED_NAT: 'UPDATE_USER_STATUS_ARCHIVED_NAT',
  UPDATE_USER_STATUS_ARCHIVED_NAT_DEPT: 'UPDATE_USER_STATUS_ARCHIVED_NAT_DEPT',

  // --- Update User Status: BANNED ---
  UPDATE_USER_STATUS_BANNED_CHURCH: 'UPDATE_USER_STATUS_BANNED_CHURCH',
  UPDATE_USER_STATUS_BANNED_CHURCH_DEPT: 'UPDATE_USER_STATUS_BANNED_CHURCH_DEPT',
  UPDATE_USER_STATUS_BANNED_DIST: 'UPDATE_USER_STATUS_BANNED_DIST',
  UPDATE_USER_STATUS_BANNED_DIST_DEPT: 'UPDATE_USER_STATUS_BANNED_DIST_DEPT',
  UPDATE_USER_STATUS_BANNED_NAT: 'UPDATE_USER_STATUS_BANNED_NAT',
  UPDATE_USER_STATUS_BANNED_NAT_DEPT: 'UPDATE_USER_STATUS_BANNED_NAT_DEPT',

  // --- Update User Status: DEACTIVATED ---
  UPDATE_USER_STATUS_DEACTIVATED_CHURCH: 'UPDATE_USER_STATUS_DEACTIVATED_CHURCH',
  UPDATE_USER_STATUS_DEACTIVATED_CHURCH_DEPT: 'UPDATE_USER_STATUS_DEACTIVATED_CHURCH_DEPT',
  UPDATE_USER_STATUS_DEACTIVATED_DIST: 'UPDATE_USER_STATUS_DEACTIVATED_DIST',
  UPDATE_USER_STATUS_DEACTIVATED_DIST_DEPT: 'UPDATE_USER_STATUS_DEACTIVATED_DIST_DEPT',
  UPDATE_USER_STATUS_DEACTIVATED_NAT: 'UPDATE_USER_STATUS_DEACTIVATED_NAT',
  UPDATE_USER_STATUS_DEACTIVATED_NAT_DEPT: 'UPDATE_USER_STATUS_DEACTIVATED_NAT_DEPT',

  // --- Update User Status: INACTIVE ---
  UPDATE_USER_STATUS_INACTIVE_CHURCH: 'UPDATE_USER_STATUS_INACTIVE_CHURCH',
  UPDATE_USER_STATUS_INACTIVE_CHURCH_DEPT: 'UPDATE_USER_STATUS_INACTIVE_CHURCH_DEPT',
  UPDATE_USER_STATUS_INACTIVE_DIST: 'UPDATE_USER_STATUS_INACTIVE_DIST',
  UPDATE_USER_STATUS_INACTIVE_DIST_DEPT: 'UPDATE_USER_STATUS_INACTIVE_DIST_DEPT',
  UPDATE_USER_STATUS_INACTIVE_NAT: 'UPDATE_USER_STATUS_INACTIVE_NAT',
  UPDATE_USER_STATUS_INACTIVE_NAT_DEPT: 'UPDATE_USER_STATUS_INACTIVE_NAT_DEPT',

  // --- Update User Status: LOCKED ---
  UPDATE_USER_STATUS_LOCKED_CHURCH: 'UPDATE_USER_STATUS_LOCKED_CHURCH',
  UPDATE_USER_STATUS_LOCKED_CHURCH_DEPT: 'UPDATE_USER_STATUS_LOCKED_CHURCH_DEPT',
  UPDATE_USER_STATUS_LOCKED_DIST: 'UPDATE_USER_STATUS_LOCKED_DIST',
  UPDATE_USER_STATUS_LOCKED_DIST_DEPT: 'UPDATE_USER_STATUS_LOCKED_DIST_DEPT',
  UPDATE_USER_STATUS_LOCKED_NAT: 'UPDATE_USER_STATUS_LOCKED_NAT',
  UPDATE_USER_STATUS_LOCKED_NAT_DEPT: 'UPDATE_USER_STATUS_LOCKED_NAT_DEPT',

  // --- Update User Status: PENDING_VERIFICATION ---
  UPDATE_USER_STATUS_PENDING_VERIFICATION_CHURCH: 'UPDATE_USER_STATUS_PENDING_VERIFICATION_CHURCH',
  UPDATE_USER_STATUS_PENDING_VERIFICATION_CHURCH_DEPT: 'UPDATE_USER_STATUS_PENDING_VERIFICATION_CHURCH_DEPT',
  UPDATE_USER_STATUS_PENDING_VERIFICATION_DIST: 'UPDATE_USER_STATUS_PENDING_VERIFICATION_DIST',
  UPDATE_USER_STATUS_PENDING_VERIFICATION_DIST_DEPT: 'UPDATE_USER_STATUS_PENDING_VERIFICATION_DIST_DEPT',
  UPDATE_USER_STATUS_PENDING_VERIFICATION_NAT: 'UPDATE_USER_STATUS_PENDING_VERIFICATION_NAT',
  UPDATE_USER_STATUS_PENDING_VERIFICATION_NAT_DEPT: 'UPDATE_USER_STATUS_PENDING_VERIFICATION_NAT_DEPT',

  // --- Update User Status: RESET ---
  UPDATE_USER_STATUS_RESET_CHURCH: 'UPDATE_USER_STATUS_RESET_CHURCH',
  UPDATE_USER_STATUS_RESET_CHURCH_DEPT: 'UPDATE_USER_STATUS_RESET_CHURCH_DEPT',
  UPDATE_USER_STATUS_RESET_DIST: 'UPDATE_USER_STATUS_RESET_DIST',
  UPDATE_USER_STATUS_RESET_DIST_DEPT: 'UPDATE_USER_STATUS_RESET_DIST_DEPT',
  UPDATE_USER_STATUS_RESET_NAT: 'UPDATE_USER_STATUS_RESET_NAT',
  UPDATE_USER_STATUS_RESET_NAT_DEPT: 'UPDATE_USER_STATUS_RESET_NAT_DEPT',

  // --- Update User Status: SUSPENDED ---
  UPDATE_USER_STATUS_SUSPENDED_CHURCH: 'UPDATE_USER_STATUS_SUSPENDED_CHURCH',
  UPDATE_USER_STATUS_SUSPENDED_CHURCH_DEPT: 'UPDATE_USER_STATUS_SUSPENDED_CHURCH_DEPT',
  UPDATE_USER_STATUS_SUSPENDED_DIST: 'UPDATE_USER_STATUS_SUSPENDED_DIST',
  UPDATE_USER_STATUS_SUSPENDED_DIST_DEPT: 'UPDATE_USER_STATUS_SUSPENDED_DIST_DEPT',
  UPDATE_USER_STATUS_SUSPENDED_NAT: 'UPDATE_USER_STATUS_SUSPENDED_NAT',
  UPDATE_USER_STATUS_SUSPENDED_NAT_DEPT: 'UPDATE_USER_STATUS_SUSPENDED_NAT_DEPT',

  // --- Enable / Disable (Active / Inactive) Actions ---
  ENABLE_DEPARTMENT: 'ENABLE_DEPARTMENT',
  DISABLE_DEPARTMENT: 'DISABLE_DEPARTMENT',
  ENABLE_DISTRICT: 'ENABLE_DISTRICT',
  DISABLE_DISTRICT: 'DISABLE_DISTRICT',
  ENABLE_CHURCH: 'ENABLE_CHURCH',
  DISABLE_CHURCH: 'DISABLE_CHURCH',
  ENABLE_ACTIVITY: 'ENABLE_ACTIVITY',
  DISABLE_ACTIVITY: 'DISABLE_ACTIVITY',
  ENABLE_KPI: 'ENABLE_KPI',
  DISABLE_KPI: 'DISABLE_KPI',
  ENABLE_REPORT_SUB_GROUP: 'ENABLE_REPORT_SUB_GROUP',
  DISABLE_REPORT_SUB_GROUP: 'DISABLE_REPORT_SUB_GROUP',

  // --- View Actions ---
  VIEW_CHURCH: 'VIEW_CHURCH',
  VIEW_CHURCH_LIST: 'VIEW_CHURCH_LIST',
  VIEW_CHURCH_USERS_LIST: 'VIEW_CHURCH_USERS_LIST',
  VIEW_DEPARTMENT: 'VIEW_DEPARTMENT',
  VIEW_DEPARTMENT_LIST: 'VIEW_DEPARTMENT_LIST',
  VIEW_DISTRICT: 'VIEW_DISTRICT',
  VIEW_DISTRICT_LIST: 'VIEW_DISTRICT_LIST',
  VIEW_DISTRICT_USERS_LIST: 'VIEW_DISTRICT_USERS_LIST',
  VIEW_INVITES_CHURCH: 'VIEW_INVITES_CHURCH',
  VIEW_INVITES_DISTRICT: 'VIEW_INVITES_DISTRICT',
  VIEW_INVITES_NATION: 'VIEW_INVITES_NATION',
  VIEW_NATION: 'VIEW_NATION',
  VIEW_NATION_LIST: 'VIEW_NATION_LIST',
  VIEW_NATION_USERS_LIST: 'VIEW_NATION_USERS_LIST',
  VIEW_CHURCH_FINANCE_STATISTICS: 'VIEW_CHURCH_FINANCE_STATISTICS',
  VIEW_DISTRICT_FINANCE_STATISTICS: 'VIEW_DISTRICT_FINANCE_STATISTICS',
  VIEW_NATION_FINANCE_STATISTICS: 'VIEW_NATION_FINANCE_STATISTICS',
} as const;

export type ActionCode = typeof ACTION_CODES[keyof typeof ACTION_CODES];

export type LeadershipMenuKey = 'pastor' | 'finance_statistics' | 'district_overseer';

export interface MenuItemConfig {
  id: string;
  label: string;
  path?: string;
  icon?: React.ReactNode;
  actionCode?: ActionCode | string;
  /** Sidebar leadership submenu visibility (from POST /user/access leadership block). */
  leadershipKey?: LeadershipMenuKey;
  children?: MenuItemConfig[];
}

/**
 * Returns the scope-specific action code for common menu-level permissions.
 * This maps a generic action (e.g., 'VIEW_USERS') to the correct backend
 * action code for the given scope (CHURCH, DISTRICT, NATION).
 */
type ReportScopedAction =
  | 'VIEW_USERS'
  | 'VIEW_INVITES'
  | 'SAVE_REPORT'
  | 'REVIEW_REPORT'
  | 'APPROVE_REPORT'
  | 'APPROVE_OWN_REPORT'
  | 'SUBMIT_REPORT'
  | 'VALIDATE_REPORT'
  | 'UPLOAD_MEDIA'
  | 'REMOVE_MEDIA'
  | 'SEND_INVITE';

type ActivityScopedAction = 'SAVE_ACTIVITY' | 'SUBMIT_ACTIVITY' | 'REVIEW_ACTIVITY';

type ScopedAction = ReportScopedAction | ActivityScopedAction;

const SCOPED_ACTION_MAP: Record<string, Record<ReportScopedAction, string>> = {
  NATION: {
    VIEW_USERS: ACTION_CODES.VIEW_NATION_USERS_LIST,
    VIEW_INVITES: ACTION_CODES.VIEW_INVITES_NATION,
    SAVE_REPORT: ACTION_CODES.SAVE_NATION_DEPARTMENT_REPORT,
    REVIEW_REPORT: ACTION_CODES.REVIEW_NATION_DEPARTMENT_REPORT,
    APPROVE_REPORT: ACTION_CODES.APPROVE_NATION_REPORT,
    APPROVE_OWN_REPORT: ACTION_CODES.APPROVE_OWN_NATION_REPORT,
    SUBMIT_REPORT: ACTION_CODES.SUBMIT_NATION_DEPARTMENT_REPORT,
    VALIDATE_REPORT: ACTION_CODES.VALIDATE_NATION_DEPARTMENT_REPORT,
    UPLOAD_MEDIA: ACTION_CODES.UPLOAD_MEDIA_NATION_DEPARTMENT_REPORT,
    REMOVE_MEDIA: ACTION_CODES.REMOVE_MEDIA_NATION_DEPARTMENT_REPORT,
    SEND_INVITE: ACTION_CODES.SEND_INVITE_NATION,
  },
  DISTRICT: {
    VIEW_USERS: ACTION_CODES.VIEW_DISTRICT_USERS_LIST,
    VIEW_INVITES: ACTION_CODES.VIEW_INVITES_DISTRICT,
    SAVE_REPORT: ACTION_CODES.SAVE_DISTRICT_DEPARTMENT_REPORT,
    REVIEW_REPORT: ACTION_CODES.REVIEW_DISTRICT_DEPARTMENT_REPORT,
    APPROVE_REPORT: ACTION_CODES.APPROVE_DISTRICT_REPORT,
    APPROVE_OWN_REPORT: ACTION_CODES.APPROVE_OWN_DISTRICT_REPORT,
    SUBMIT_REPORT: ACTION_CODES.SUBMIT_DISTRICT_DEPARTMENT_REPORT,
    VALIDATE_REPORT: ACTION_CODES.VALIDATE_DISTRICT_DEPARTMENT_REPORT,
    UPLOAD_MEDIA: ACTION_CODES.UPLOAD_MEDIA_DISTRICT_DEPARTMENT_REPORT,
    REMOVE_MEDIA: ACTION_CODES.REMOVE_MEDIA_DISTRICT_DEPARTMENT_REPORT,
    SEND_INVITE: ACTION_CODES.SEND_INVITE_DISTRICT,
  },
  CHURCH: {
    VIEW_USERS: ACTION_CODES.VIEW_CHURCH_USERS_LIST,
    VIEW_INVITES: ACTION_CODES.VIEW_INVITES_CHURCH,
    SAVE_REPORT: ACTION_CODES.SAVE_CHURCH_DEPARTMENT_REPORT,
    REVIEW_REPORT: ACTION_CODES.REVIEW_CHURCH_DEPARTMENT_REPORT,
    APPROVE_REPORT: ACTION_CODES.APPROVE_CHURCH_REPORT,
    APPROVE_OWN_REPORT: ACTION_CODES.APPROVE_OWN_CHURCH_REPORT,
    SUBMIT_REPORT: ACTION_CODES.SUBMIT_CHURCH_DEPARTMENT_REPORT,
    VALIDATE_REPORT: ACTION_CODES.VALIDATE_CHURCH_DEPARTMENT_REPORT,
    UPLOAD_MEDIA: ACTION_CODES.UPLOAD_MEDIA_CHURCH_DEPARTMENT_REPORT,
    REMOVE_MEDIA: ACTION_CODES.REMOVE_MEDIA_CHURCH_DEPARTMENT_REPORT,
    SEND_INVITE: ACTION_CODES.SEND_INVITE_CHURCH,
  },
};

/** Maps route-style scope values (e.g. nation) to permission API keys (NATION). */
function normalizePermissionScope(scope: string): string {
  return getScopeFromValue(scope) || scope.toUpperCase();
}

export const getScopedActionCode = (scope: string, action: ScopedAction): string => {
  const normalized = normalizePermissionScope(scope);
  if (action === 'SAVE_ACTIVITY' || action === 'SUBMIT_ACTIVITY' || action === 'REVIEW_ACTIVITY') {
    const activityAction =
      action === 'SAVE_ACTIVITY' ? 'save' : action === 'SUBMIT_ACTIVITY' ? 'submit' : 'review';
    return ACTIVITY_ENTRY_SCOPED_MAP[normalized]?.[activityAction] ?? '';
  }
  return SCOPED_ACTION_MAP[normalized]?.[action as ReportScopedAction] || '';
};

export const getFinanceStatisticsActionForScope = (scope: string): string => {
  const normalized = normalizePermissionScope(scope);
  const map: Record<string, string> = {
    NATION: ACTION_CODES.VIEW_NATION_FINANCE_STATISTICS,
    DISTRICT: ACTION_CODES.VIEW_DISTRICT_FINANCE_STATISTICS,
    CHURCH: ACTION_CODES.VIEW_CHURCH_FINANCE_STATISTICS,
  };
  return map[normalized] ?? ACTION_CODES.VIEW_CHURCH_FINANCE_STATISTICS;
};

/** Action codes used by department report pages at a given scope. */
export const getReportActionCodesForScope = (scope: string): string[] => {
  return [
    getScopedActionCode(scope, 'SAVE_REPORT'),
    getScopedActionCode(scope, 'SUBMIT_REPORT'),
    getScopedActionCode(scope, 'REVIEW_REPORT'),
    getScopedActionCode(scope, 'APPROVE_REPORT'),
    getScopedActionCode(scope, 'VALIDATE_REPORT'),
    getScopedActionCode(scope, 'UPLOAD_MEDIA'),
    getScopedActionCode(scope, 'REMOVE_MEDIA'),
  ].filter(Boolean);
};

/** Scoped action codes for activity entry by origin scope. */
const ACTIVITY_ENTRY_SCOPED_MAP: Record<string, { save: string; submit: string; review: string }> = {
  NATION: {
    save: ACTION_CODES.SAVE_NATION_ACTIVITY_ENTRY,
    submit: ACTION_CODES.SUBMIT_NATION_ACTIVITY_ENTRY,
    review: ACTION_CODES.REVIEW_NATION_ACTIVITY_ENTRY,
  },
  DISTRICT: {
    save: ACTION_CODES.SAVE_DISTRICT_ACTIVITY_ENTRY,
    submit: ACTION_CODES.SUBMIT_DISTRICT_ACTIVITY_ENTRY,
    review: ACTION_CODES.REVIEW_DISTRICT_ACTIVITY_ENTRY,
  },
  CHURCH: {
    save: ACTION_CODES.SAVE_CHURCH_ACTIVITY_ENTRY,
    submit: ACTION_CODES.SUBMIT_CHURCH_ACTIVITY_ENTRY,
    review: ACTION_CODES.REVIEW_CHURCH_ACTIVITY_ENTRY,
  },
};

export const getActivityEntryActionCodesForScope = (scope: string): string[] => {
  const normalized = normalizePermissionScope(scope);
  const codes = ACTIVITY_ENTRY_SCOPED_MAP[normalized];
  if (!codes) return [];
  return [codes.save, codes.submit, codes.review];
};

export const getScopedActivityEntryCode = (
  scope: string,
  action: 'save' | 'submit' | 'review'
): string => {
  const normalized = normalizePermissionScope(scope);
  return ACTIVITY_ENTRY_SCOPED_MAP[normalized]?.[action] ?? '';
};

/** Template origin CREATE codes — used for gating template catalog row actions. */
export const TEMPLATE_ORIGIN_CREATE_CODES = [
  ACTION_CODES.CREATE_CHURCH_REPORT_TEMPLATE,
  ACTION_CODES.CREATE_DISTRICT_REPORT_TEMPLATE,
  ACTION_CODES.CREATE_NATION_REPORT_TEMPLATE,
] as const;

/** Map origin scope to CREATE action code. */
export const getTemplateOriginCreateCode = (originScope: string): string => {
  const normalized = normalizePermissionScope(originScope);
  const map: Record<string, string> = {
    NATION: ACTION_CODES.CREATE_NATION_REPORT_TEMPLATE,
    DISTRICT: ACTION_CODES.CREATE_DISTRICT_REPORT_TEMPLATE,
    CHURCH: ACTION_CODES.CREATE_CHURCH_REPORT_TEMPLATE,
  };
  return map[normalized] ?? '';
};

/** Map origin scope to UPDATE_*_REPORT_TEMPLATE_ORIGIN action code. */
export const getTemplateOriginUpdateCode = (originScope: string): string => {
  const normalized = normalizePermissionScope(originScope);
  const map: Record<string, string> = {
    NATION: ACTION_CODES.UPDATE_NATION_REPORT_TEMPLATE_ORIGIN,
    DISTRICT: ACTION_CODES.UPDATE_DISTRICT_REPORT_TEMPLATE_ORIGIN,
    CHURCH: ACTION_CODES.UPDATE_CHURCH_REPORT_TEMPLATE_ORIGIN,
  };
  return map[normalized] ?? '';
};

/** Document category origin CREATE codes. */
export const DOCUMENT_CATEGORY_ORIGIN_CREATE_CODES = [
  ACTION_CODES.CREATE_CHURCH_DEPARTMENT_REPORT_DOCUMENT_CATEGORY,
  ACTION_CODES.CREATE_DISTRICT_DEPARTMENT_REPORT_DOCUMENT_CATEGORY,
  ACTION_CODES.CREATE_NATION_DEPARTMENT_REPORT_DOCUMENT_CATEGORY,
] as const;

export const DOCUMENT_CATEGORY_MANAGE_CODES = [
  ...DOCUMENT_CATEGORY_ORIGIN_CREATE_CODES,
  ACTION_CODES.UPDATE_CHURCH_DEPARTMENT_REPORT_DOCUMENT_CATEGORY,
  ACTION_CODES.UPDATE_DISTRICT_DEPARTMENT_REPORT_DOCUMENT_CATEGORY,
  ACTION_CODES.UPDATE_NATION_DEPARTMENT_REPORT_DOCUMENT_CATEGORY,
  ACTION_CODES.REMOVE_CHURCH_DEPARTMENT_REPORT_DOCUMENT_CATEGORY,
  ACTION_CODES.REMOVE_DISTRICT_DEPARTMENT_REPORT_DOCUMENT_CATEGORY,
  ACTION_CODES.REMOVE_NATION_DEPARTMENT_REPORT_DOCUMENT_CATEGORY,
  ACTION_CODES.ENABLE_CHURCH_DEPARTMENT_REPORT_DOCUMENT_CATEGORY,
  ACTION_CODES.ENABLE_DISTRICT_DEPARTMENT_REPORT_DOCUMENT_CATEGORY,
  ACTION_CODES.ENABLE_NATION_DEPARTMENT_REPORT_DOCUMENT_CATEGORY,
  ACTION_CODES.DISABLE_CHURCH_DEPARTMENT_REPORT_DOCUMENT_CATEGORY,
  ACTION_CODES.DISABLE_DISTRICT_DEPARTMENT_REPORT_DOCUMENT_CATEGORY,
  ACTION_CODES.DISABLE_NATION_DEPARTMENT_REPORT_DOCUMENT_CATEGORY,
  ACTION_CODES.UPDATE_CHURCH_DEPARTMENT_REPORT_DOCUMENT_CATEGORY_ORIGIN,
  ACTION_CODES.UPDATE_DISTRICT_DEPARTMENT_REPORT_DOCUMENT_CATEGORY_ORIGIN,
  ACTION_CODES.UPDATE_NATION_DEPARTMENT_REPORT_DOCUMENT_CATEGORY_ORIGIN,
] as const;

export const getDocumentCategoryCreateCode = (originScope: string): string => {
  const normalized = normalizePermissionScope(originScope);
  const map: Record<string, string> = {
    CHURCH: ACTION_CODES.CREATE_CHURCH_DEPARTMENT_REPORT_DOCUMENT_CATEGORY,
    DISTRICT: ACTION_CODES.CREATE_DISTRICT_DEPARTMENT_REPORT_DOCUMENT_CATEGORY,
    NATION: ACTION_CODES.CREATE_NATION_DEPARTMENT_REPORT_DOCUMENT_CATEGORY,
  };
  return map[normalized] ?? '';
};

export const getDocumentCategoryOriginUpdateCode = (originScope: string): string => {
  const normalized = normalizePermissionScope(originScope);
  const map: Record<string, string> = {
    CHURCH: ACTION_CODES.UPDATE_CHURCH_DEPARTMENT_REPORT_DOCUMENT_CATEGORY_ORIGIN,
    DISTRICT: ACTION_CODES.UPDATE_DISTRICT_DEPARTMENT_REPORT_DOCUMENT_CATEGORY_ORIGIN,
    NATION: ACTION_CODES.UPDATE_NATION_DEPARTMENT_REPORT_DOCUMENT_CATEGORY_ORIGIN,
  };
  return map[normalized] ?? '';
};

export const getDocumentCategoryCodesForOrigin = (originScope: string) => {
  const normalized = normalizePermissionScope(originScope);
  const map: Record<string, { update: string; remove: string; enable: string; disable: string }> = {
    CHURCH: {
      update: ACTION_CODES.UPDATE_CHURCH_DEPARTMENT_REPORT_DOCUMENT_CATEGORY,
      remove: ACTION_CODES.REMOVE_CHURCH_DEPARTMENT_REPORT_DOCUMENT_CATEGORY,
      enable: ACTION_CODES.ENABLE_CHURCH_DEPARTMENT_REPORT_DOCUMENT_CATEGORY,
      disable: ACTION_CODES.DISABLE_CHURCH_DEPARTMENT_REPORT_DOCUMENT_CATEGORY,
    },
    DISTRICT: {
      update: ACTION_CODES.UPDATE_DISTRICT_DEPARTMENT_REPORT_DOCUMENT_CATEGORY,
      remove: ACTION_CODES.REMOVE_DISTRICT_DEPARTMENT_REPORT_DOCUMENT_CATEGORY,
      enable: ACTION_CODES.ENABLE_DISTRICT_DEPARTMENT_REPORT_DOCUMENT_CATEGORY,
      disable: ACTION_CODES.DISABLE_DISTRICT_DEPARTMENT_REPORT_DOCUMENT_CATEGORY,
    },
    NATION: {
      update: ACTION_CODES.UPDATE_NATION_DEPARTMENT_REPORT_DOCUMENT_CATEGORY,
      remove: ACTION_CODES.REMOVE_NATION_DEPARTMENT_REPORT_DOCUMENT_CATEGORY,
      enable: ACTION_CODES.ENABLE_NATION_DEPARTMENT_REPORT_DOCUMENT_CATEGORY,
      disable: ACTION_CODES.DISABLE_NATION_DEPARTMENT_REPORT_DOCUMENT_CATEGORY,
    },
  };
  return map[normalized];
};

export type PresentationLayoutOriginCodes = {
  create: string;
  update: string;
  enable: string;
  disable: string;
  delete: string;
  updateOrigin: string;
};

const PRESENTATION_LAYOUT_CODES_BY_ORIGIN: Record<string, PresentationLayoutOriginCodes> = {
  CHURCH: {
    create: ACTION_CODES.CREATE_CHURCH_PRESENTATION_LAYOUT,
    update: ACTION_CODES.UPDATE_CHURCH_PRESENTATION_LAYOUT,
    enable: ACTION_CODES.ENABLE_CHURCH_PRESENTATION_LAYOUT,
    disable: ACTION_CODES.DISABLE_CHURCH_PRESENTATION_LAYOUT,
    delete: ACTION_CODES.DELETE_CHURCH_PRESENTATION_LAYOUT,
    updateOrigin: ACTION_CODES.UPDATE_CHURCH_PRESENTATION_LAYOUT_ORIGIN,
  },
  DISTRICT: {
    create: ACTION_CODES.CREATE_DISTRICT_PRESENTATION_LAYOUT,
    update: ACTION_CODES.UPDATE_DISTRICT_PRESENTATION_LAYOUT,
    enable: ACTION_CODES.ENABLE_DISTRICT_PRESENTATION_LAYOUT,
    disable: ACTION_CODES.DISABLE_DISTRICT_PRESENTATION_LAYOUT,
    delete: ACTION_CODES.DELETE_DISTRICT_PRESENTATION_LAYOUT,
    updateOrigin: ACTION_CODES.UPDATE_DISTRICT_PRESENTATION_LAYOUT_ORIGIN,
  },
  NATION: {
    create: ACTION_CODES.CREATE_NATION_PRESENTATION_LAYOUT,
    update: ACTION_CODES.UPDATE_NATION_PRESENTATION_LAYOUT,
    enable: ACTION_CODES.ENABLE_NATION_PRESENTATION_LAYOUT,
    disable: ACTION_CODES.DISABLE_NATION_PRESENTATION_LAYOUT,
    delete: ACTION_CODES.DELETE_NATION_PRESENTATION_LAYOUT,
    updateOrigin: ACTION_CODES.UPDATE_NATION_PRESENTATION_LAYOUT_ORIGIN,
  },
};

/** Every presentation layout action; the department kebab entry shows when the user holds any of them. */
export const PRESENTATION_LAYOUT_MANAGE_CODES = Object.values(PRESENTATION_LAYOUT_CODES_BY_ORIGIN)
  .flatMap((codes) => Object.values(codes));

export const getPresentationLayoutCodesForOrigin = (originScope: string): PresentationLayoutOriginCodes | undefined =>
  PRESENTATION_LAYOUT_CODES_BY_ORIGIN[normalizePermissionScope(originScope)];

/** Map origin scope to ENABLE / DISABLE / UPDATE catalog codes. */
export const getTemplateCatalogCodesForOrigin = (originScope: string) => {
  const normalized = normalizePermissionScope(originScope);
  const map: Record<string, { update: string; enable: string; disable: string; assignActivity: string; removeActivity: string }> = {
    CHURCH: {
      update: ACTION_CODES.UPDATE_CHURCH_REPORT_TEMPLATE,
      enable: ACTION_CODES.ENABLE_CHURCH_REPORT_TEMPLATE,
      disable: ACTION_CODES.DISABLE_CHURCH_REPORT_TEMPLATE,
      assignActivity: ACTION_CODES.ASSIGN_CHURCH_REPORT_TEMPLATE_ACTIVITY,
      removeActivity: ACTION_CODES.REMOVE_CHURCH_REPORT_TEMPLATE_ACTIVITY,
    },
    DISTRICT: {
      update: ACTION_CODES.UPDATE_DISTRICT_REPORT_TEMPLATE,
      enable: ACTION_CODES.ENABLE_DISTRICT_REPORT_TEMPLATE,
      disable: ACTION_CODES.DISABLE_DISTRICT_REPORT_TEMPLATE,
      assignActivity: ACTION_CODES.ASSIGN_DISTRICT_REPORT_TEMPLATE_ACTIVITY,
      removeActivity: ACTION_CODES.REMOVE_DISTRICT_REPORT_TEMPLATE_ACTIVITY,
    },
    NATION: {
      update: ACTION_CODES.UPDATE_NATION_REPORT_TEMPLATE,
      enable: ACTION_CODES.ENABLE_NATION_REPORT_TEMPLATE,
      disable: ACTION_CODES.DISABLE_NATION_REPORT_TEMPLATE,
      assignActivity: ACTION_CODES.ASSIGN_NATION_REPORT_TEMPLATE_ACTIVITY,
      removeActivity: ACTION_CODES.REMOVE_NATION_REPORT_TEMPLATE_ACTIVITY,
    },
  };
  return map[normalized];
};

/** Any catalog manage code (for zero-manage redirect). */
export const TEMPLATE_CATALOG_MANAGE_CODES = [
  ...TEMPLATE_ORIGIN_CREATE_CODES,
  ACTION_CODES.UPDATE_CHURCH_REPORT_TEMPLATE,
  ACTION_CODES.UPDATE_DISTRICT_REPORT_TEMPLATE,
  ACTION_CODES.UPDATE_NATION_REPORT_TEMPLATE,
  ACTION_CODES.ENABLE_CHURCH_REPORT_TEMPLATE,
  ACTION_CODES.ENABLE_DISTRICT_REPORT_TEMPLATE,
  ACTION_CODES.ENABLE_NATION_REPORT_TEMPLATE,
  ACTION_CODES.DISABLE_CHURCH_REPORT_TEMPLATE,
  ACTION_CODES.DISABLE_DISTRICT_REPORT_TEMPLATE,
  ACTION_CODES.DISABLE_NATION_REPORT_TEMPLATE,
  ACTION_CODES.ASSIGN_CHURCH_REPORT_TEMPLATE_ACTIVITY,
  ACTION_CODES.ASSIGN_DISTRICT_REPORT_TEMPLATE_ACTIVITY,
  ACTION_CODES.ASSIGN_NATION_REPORT_TEMPLATE_ACTIVITY,
  ACTION_CODES.REMOVE_CHURCH_REPORT_TEMPLATE_ACTIVITY,
  ACTION_CODES.REMOVE_DISTRICT_REPORT_TEMPLATE_ACTIVITY,
  ACTION_CODES.REMOVE_NATION_REPORT_TEMPLATE_ACTIVITY,
  ACTION_CODES.ASSIGN_CHURCH_REPORT_TEMPLATE_SUB_GROUP,
  ACTION_CODES.ASSIGN_DISTRICT_REPORT_TEMPLATE_SUB_GROUP,
  ACTION_CODES.ASSIGN_NATION_REPORT_TEMPLATE_SUB_GROUP,
  ACTION_CODES.REMOVE_CHURCH_REPORT_TEMPLATE_SUB_GROUP,
  ACTION_CODES.REMOVE_DISTRICT_REPORT_TEMPLATE_SUB_GROUP,
  ACTION_CODES.REMOVE_NATION_REPORT_TEMPLATE_SUB_GROUP,
  ACTION_CODES.UPDATE_CHURCH_REPORT_TEMPLATE_ORIGIN,
  ACTION_CODES.UPDATE_DISTRICT_REPORT_TEMPLATE_ORIGIN,
  ACTION_CODES.UPDATE_NATION_REPORT_TEMPLATE_ORIGIN,
] as const;

/** Bulk assignment codes for template assignment. */
export const BULK_TEMPLATE_ASSIGN_CODES = [
  ACTION_CODES.BULK_ASSIGN_CHURCH_REPORT_TEMPLATE,
  ACTION_CODES.BULK_ASSIGN_DISTRICT_REPORT_TEMPLATE,
  ACTION_CODES.BULK_UNASSIGN_CHURCH_REPORT_TEMPLATE,
  ACTION_CODES.BULK_UNASSIGN_DISTRICT_REPORT_TEMPLATE,
] as const;

/** Get scoped template assign code. */
export const getScopedTemplateAssignCode = (scope: string): string => {
  const normalized = normalizePermissionScope(scope);
  const map: Record<string, string> = {
    NATION: ACTION_CODES.ASSIGN_NATION_REPORT_TEMPLATE,
    DISTRICT: ACTION_CODES.ASSIGN_DISTRICT_REPORT_TEMPLATE,
    CHURCH: ACTION_CODES.ASSIGN_CHURCH_REPORT_TEMPLATE,
  };
  return map[normalized] ?? '';
};

/** Get scoped template sync code (Manage Templates modal save). */
export const getScopedTemplateSyncCode = (scope: string): string => {
  const normalized = normalizePermissionScope(scope);
  const map: Record<string, string> = {
    NATION: ACTION_CODES.SYNC_NATION_REPORT_TEMPLATE,
    DISTRICT: ACTION_CODES.SYNC_DISTRICT_REPORT_TEMPLATE,
    CHURCH: ACTION_CODES.SYNC_CHURCH_REPORT_TEMPLATE,
  };
  return map[normalized] ?? '';
};
